<template>
    <footer class="bg-[#17364a] text-white">
        <!-- Gold top line -->
        <div class="h-px bg-[#A07830]"></div>

        <div class="mx-auto max-w-7xl px-6 lg:px-8 py-16">
            <div class="grid grid-cols-1 gap-10 sm:grid-cols-2 lg:grid-cols-4">

                <!-- Col 1: Logo + tagline -->
                <div class="lg:col-span-1">
                    <img
                        src="/images/logo.png"
                        alt="Nobel Academy"
                        class="h-12 w-auto object-contain brightness-0 invert mb-4"
                    />
                    <p class="text-sm text-gray-400 leading-relaxed max-w-xs">
                        Join us and experience an enriching journey through our online learning programs across a wide range of subjects.
                    </p>
                    <!-- Social -->
                    <div class="mt-6 flex items-center gap-4">
                        <a v-for="social in socials" :key="social.name" :href="social.href" target="_blank" rel="noopener noreferrer"
                            class="text-gray-500 hover:text-[#A07830] transition-colors duration-200" :aria-label="social.name">
                            <component :is="social.icon" class="h-5 w-5" />
                        </a>
                    </div>
                </div>

                <!-- Col 2: Quick Links -->
                <div>
                    <h3 class="text-xs font-semibold uppercase tracking-widest text-[#A07830] mb-5">Quick Links</h3>
                    <ul class="space-y-3">
                        <li v-for="link in quickLinks" :key="link.name">
                            <router-link :to="link.href"
                                class="text-sm text-gray-400 hover:text-white transition-colors duration-200">
                                {{ link.name }}
                            </router-link>
                        </li>
                    </ul>
                </div>

                <!-- Col 3: Courses -->
                <div>
                    <h3 class="text-xs font-semibold uppercase tracking-widest text-[#A07830] mb-5">Programs</h3>
                    <ul class="space-y-3">
                        <li v-for="link in programLinks" :key="link.name">
                            <router-link :to="link.href"
                                class="text-sm text-gray-400 hover:text-white transition-colors duration-200">
                                {{ link.name }}
                            </router-link>
                        </li>
                    </ul>
                </div>

                <!-- Col 4: Newsletter -->
                <div>
                    <h3 class="text-xs font-semibold uppercase tracking-widest text-[#A07830] mb-5">Newsletter</h3>
                    <p class="text-sm text-gray-400 mb-4">Stay updated with our latest courses and news.</p>
                    <div class="flex">
                        <label for="footer-email" class="sr-only">Email address</label>
                        <input
                            id="footer-email"
                            name="email"
                            type="email"
                            autocomplete="email"
                            placeholder="your@email.com"
                            class="flex-1 min-w-0 bg-[#102a3a] border border-[#1e4d63] px-3 py-2 text-sm text-white placeholder-gray-600 focus:outline-none focus:border-[#A07830] transition-colors"
                        />
                        <button
                            type="submit"
                            class="shrink-0 px-4 py-2 text-sm font-semibold bg-[#A07830] text-white hover:bg-[#C9A55A] transition-colors duration-200"
                        >
                            Subscribe
                        </button>
                    </div>
                </div>

            </div>
        </div>

        <!-- Bottom bar -->
        <div class="border-t border-[#1e4d63]">
            <div class="mx-auto max-w-7xl px-6 lg:px-8 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
                <p class="text-xs text-gray-600">
                    &copy; {{ new Date().getFullYear() }} Nobel Academy. All rights reserved.
                </p>
                <div class="flex items-center gap-5">
                    <router-link to="/privacy-policy" class="text-xs text-gray-600 hover:text-gray-400 transition-colors">Privacy Policy</router-link>
                    <router-link to="/contact-us" class="text-xs text-gray-600 hover:text-gray-400 transition-colors">Contact</router-link>
                </div>
            </div>
        </div>
    </footer>
</template>

<script setup>
import { GlobeAltIcon, PhoneIcon, EnvelopeIcon } from '@heroicons/vue/24/outline';

const socials = [
    { name: 'Website', href: '#', icon: GlobeAltIcon },
    { name: 'Phone', href: 'tel:+1234567890', icon: PhoneIcon },
    { name: 'Email', href: 'mailto:info@nobelacademy.com', icon: EnvelopeIcon },
];

const quickLinks = [
    { name: 'Home', href: '/' },
    { name: 'About Us', href: '/about-us' },
    { name: 'Contact Us', href: '/contact-us' },
    { name: 'Privacy Policy', href: '/privacy-policy' },
];

const programLinks = [
    { name: 'All Courses', href: '/courses' },
    { name: 'Books', href: '/books' },
    { name: 'Learning Dashboard', href: '/learning' },
];
</script>
